/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { PersonalisedSuggestionRequest, PlaintextApiResponse } from '@mta/vela-api-types'

import { apiFetch } from '@/lib/api/api-fetch'
import { ApiResult } from '@/lib/api/api-result'

/**
 * Submits a personalised suggestion request to the backend.
 */
export const submitPersonalisedSuggestionRequest = (
  userType: string,
  activityScope: string,
  learningObjective: string,
  deliveryMethod: string,
  duration: string,
  targetAudience: string,
  additionalInfo: string,
  name: string,
  email: string,
): Promise<ApiResult<PlaintextApiResponse>> => {
  return apiFetch<PlaintextApiResponse, PersonalisedSuggestionRequest>('contact/personalised-suggestion', 'POST', {
    userType,
    activityScope,
    learningObjective,
    deliveryMethod,
    duration,
    targetAudience,
    additionalInfo,
    name,
    email,
  })
}
